import JsonBigInt from './src/main.js';

export default JsonBigInt